export default "__VITE_ASSET__BgHrVp8z__"